import PageHeader from "../PageHeader.js";
import { ReactComponent as LearnerIcon } from "../../images/mainheadingicon/dashboard.svg";
import useStyles from "../../../styles.js";
import ReportHeader from "../../CustomComponent/ReportHeader.js";
import { Report2Api } from "../../../service/services.js";
import { decryptData } from "../../../crypto.js";
import Loader from "../../CustomComponent/Loader.js";
import { useState, useEffect } from "react";
import ViewSyncDashboard from "./ViewSyncDashboard.js";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

function SyncDashboard() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedCenter, setSelectedCenter] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");
  const [date, setDate] = useState("");
  const [data, setData] = useState([]);
  const [column, setColumn] = useState([]);
 const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);
  const [page, setPage] = useState(0);


  const [filterData, setFilterData] = useState({
    page: page,
    limit: pageSize,
    learner_download: "",
    exam_download: "",
    sync_status: "",
    result_genrate: "",
    exam_started: "",
    center_name: "",
    branch_name: "",
  });

  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Sync Dashboard",
    },
  ];

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/sync/status?page=${
          filterData.page
        }&limit=${filterData.limit}&date=${date}&exam_id=${
          selectedExam ? selectedExam?.join(",") : ""
        }&center_id=${selectedCenter ? selectedCenter?.join(",") : ""}&exam_type=${
          selectedExamType || ""
        }`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (response.data.syncs.length === 0) {
        toast.warning("data not available on this date");
      }

      setData(response.data.syncs);
      setColumn([
        "Branch",
        "Center",
        "Learner Data Download",
        "Exam Data Download",
        // "Exam Started",
        "Sync Status",
        "Result Generated",
      ]);
    } catch (error) {
      console.error("Error fetching data: ", error);
      toast.warning(error?.response?.data?.message || "data not found");
    }
  };

  const dataUpDateInDatabase = async () => {
try {
  const response = await axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/sync/status`,
    {
      sync: {
        date: new Date().toISOString().split("T")[0],
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  console.log("API Response:", response.data);
} catch (error) {
  console.error("Error updating API:", error);
}
  };

  // useEffect(() => {
  //   fetchData();
  // }, [filterData]);

  useEffect(() => {
    // Call API once immediately
    dataUpDateInDatabase();

    // Set interval for every 5 minutes (300000 ms)
    const interval = setInterval(dataUpDateInDatabase, 5 * 60 * 1000);

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <ReportHeader
        exportApi={Report2Api}
        fetchData={fetchData}
        setLoaderOpen={setLoaderOpen}
        setSelectedExam={setSelectedExam}
        selectedExam={selectedExam}
        selectedCenter={selectedCenter}
        setSelectedCenter={setSelectedCenter}
        selectedExamType={selectedExamType}
        setSelectedExamType={setSelectedExamType}
        showSave={false}
        examBase={false}
        setDate={setDate}
      />
      <ViewSyncDashboard
        selectedExam={selectedExam}
        cources={data}
        column={column}
        filterData={filterData}
        page={page}
        pageSize={pageSize}
        onPage={onPage}
        setPage={setPage}
        setPageSize={setPageSize}
        setOnPage={setOnPage}
        setFilterData={setFilterData}
      />
      <ToastContainer />
    </div>
  );
}
export default SyncDashboard;
